<template>
  <el-dialog
    v-bind="$attrs"
    v-on="$listeners"
    ref="dialog"
    :close-on-click-modal="false"
    :class="['dialog-dark', 'password-luck-detail-dialog', {'hide-dialog': luckAudienceVisible}]"
    :title="$t('passwordLuckDetail.抽奖详情')"
    width="360px"
    @open="onOpen"
    @close="onClose"
  >
    <div class="detail_box">
      <div class="submit-count-box">
        <div class="title">{{ $t('passwordLuckDetail.参与人数') }}</div>
        <div class="count">{{ luckDetailSubmitCount }}</div>
        <a class="audience-list-link" @click="openAudienceList">{{ $t('passwordLuckDetail.抽奖观众') }}</a>
      </div>

      <div class="submit-count-box count-down-date-box" v-if="autoDraw">
        <div class="title">{{ $t('passwordLuckDetail.抽奖倒计时') }}</div>
        <div class="count format-date">{{ formatCountdownDateStr }}</div>
      </div>
    </div>

    <div slot="footer" class="detail-footer">
      <el-button
        class="button-mini"
        size="mini"
        @click="cancelPasswordRaffle()"
        >{{$t('passwordLuckDetail.取消抽奖')}}</el-button
      >

      <el-button
        class="button-mini btn-mini"
        type="primary"
        size="mini"
        @click="drawPasswordRaffle()"
        >{{$t('passwordLuckDetail.开始抽奖')}}</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { Dialog, Table, TableColumn } from "element-ui";
import {
  drawPasswordRaffle,
  cancelPasswordRaffle
} from "@/api/liveRequest/luckDawApi";

export default {
  name: "PasswordLuckDetail",
  components: {
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  props: {
    raffleId: String,
    luckAudienceVisible: Boolean,
    luckDetailSubmitCount: Number,
    runningRaffleData: {
      type: [Object, undefined], // 指定类型为 Object 或 undefined
      default: undefined // 设置默认值为 undefined
    }
  },
  beforeDestroy() {
    this.onClose();
  },
  data() {
    return {
      isVisible: true,
      formatCountdownDateStr: '-:-',
      timer: undefined,
      hasConfirmPromise: false,
      autoDraw: false,
    };
  },
  methods: {
    onOpen () {
      this.isVisible = true;
      this.timer && clearInterval(this.timer);
      this.timer = undefined;
      this.hasConfirmPromise && this.$msgbox.close();
      this.hasConfirmPromise = false;

      const {minutes: minutesTmp, seconds: secondsTmp} = this.currFormatCountdown();
      this.formatCountdownDateStr = `${minutesTmp}:${secondsTmp}`;
      console.log(this.runningRaffleData, "倒计时数组")
      this.autoDraw = this.runningRaffleData.autoDraw;
      if (!this.runningRaffleData)
        return;

      this.timer = setInterval(() => {
        if (!this.isVisible) {
          this.timer && clearInterval(this.timer);
          this.timer = undefined;
          return;
        }

        const {minutes, seconds} = this.currFormatCountdown();
        this.formatCountdownDateStr = `${minutes}:${seconds}`;
      }, 1000);
    },
    onClose () {
      this.isVisible = false;
      this.timer && clearInterval(this.timer);
      this.timer = undefined;
      this.hasConfirmPromise && this.$msgbox.close();
      this.hasConfirmPromise = false;
    },
    currFormatCountdown () {
      if (!this.runningRaffleData)
        return {minutes: '-', seconds: '-'};
      
      const nowTs = Date.now();
      const {sendTime, drawCountdown} = this.runningRaffleData;
      let diffSec = drawCountdown - Math.floor((nowTs - sendTime)/1000);
      if (diffSec < 0)
        diffSec = 0;
      else if (diffSec > drawCountdown)
        diffSec = drawCountdown;

      const minutesTmp = Math.floor(diffSec/60);
      const secondsTmp = diffSec - minutesTmp * 60;

      return {minutes: `${minutesTmp < 10 ? '0':''}${minutesTmp}`, seconds: `${secondsTmp < 10 ? '0':''}${secondsTmp}`}
    },
    drawPasswordRaffle () {
      const raffleId = this.raffleId;
      console.log('drawPasswordRaffle step1, raffleId:', raffleId);
      this.hasConfirmPromise = true;
      this.$confirm(this.$t('passwordLuckDetail.尚未到达指定开奖时间，确定开奖吗'), this.$t('passwordLuckDetail.提示'), {
        confirmButtonText: this.$t('passwordLuckDetail.确定'),
        cancelButtonText: this.$t('passwordLuckDetail.取消'),
      }).then(() => {
        this.hasConfirmPromise = false;
        console.log('drawPasswordRaffle step2, raffleId:', raffleId, ' ,isVisible:', this.isVisible);
        if (!this.isVisible || !this.raffleId || raffleId !== this.raffleId) return;

        drawPasswordRaffle({raffleId: raffleId})
          .then((res) => {
            if (!this.isVisible || !this.raffleId || raffleId !== this.raffleId || res.code !== 200)
              return;
            
            this.$emit('setLuckDetailVisible', false);
            this.$emit('setLuckedVisible', true);
          });
      }).catch(() => {
        this.hasConfirmPromise = false;
      });
    },
    cancelPasswordRaffle () {
      const raffleId = this.raffleId;
      console.log('cancelPasswordRaffle step1, raffleId:', raffleId);
      this.hasConfirmPromise = true;
      this.$confirm(this.$t('passwordLuckDetail.确认取消抽奖吗'), this.$t('passwordLuckDetail.提示'), {
        confirmButtonText: this.$t('passwordLuckDetail.确定'),
        cancelButtonText: this.$t('passwordLuckDetail.取消'),
      }).then(() => {
        this.hasConfirmPromise = false;
        console.log('cancelPasswordRaffle step2, raffleId:', raffleId, ' ,isVisible:', this.isVisible);
        if (!this.isVisible || !this.raffleId || raffleId !== this.raffleId)
          return;

        cancelPasswordRaffle({raffleId: raffleId})
          .then(() => {
            if (!this.isVisible || !this.raffleId || raffleId !== this.raffleId)
              return;

            this.$emit('setLuckDetailVisible', false);
          });
      }).catch(() => {
        this.hasConfirmPromise = false;
      });
    },
    openAudienceList () {
      this.$emit('setLuckAudienceVisible', true);
    }
  },
};
</script>

<style lang="scss" scoped>
.password-luck-detail-dialog {
  &.hide-dialog {
    display: none;
  }

  .audience-list-link {
    color: #3986EE;
    cursor: pointer;
  }
}
.detail_box{
  display: flex;
  justify-content: space-around;
  width:100%;
  .submit-count-box{
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    width:158px; 
  }
  .count-down-date-box{
    border-right: none;
    justify-content: flex-start;
    border-left: 1px solid #444767;
  }
  .title{
    font-size: 12px;
    font-weight: 500;
  }
  .count{
    font-size: 42px;
    text-align: center;
  }
}
.detail-footer{
  text-align: center;
  .btn-mini{
    margin-left: 18px;
  }
}
</style>
